import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Select.MenuItems', {
    noData: 'No data',
    addCreatableItemText: 'Add "{name}"',
});
